module.exports = __webpack_public_path__ + "img/logo-school-2.7dfc3fde.png";